import React, { useEffect, useRef, useState } from "react";
import { drawTables } from "./component/drawTables";
import { Get, Post } from "../../../actions";
import { getTableAtPosition } from "./component/getTableAtPosition";
import TableDialog from "./TableDialog";
import { Box, Button, TextField } from "@material-ui/core";
import { AddNewTable } from "./component/addNewTableDialog";
import { CircularTable, HorizontalTable, VerticleTable } from "./Table.jsx";
import Draggable from "react-draggable";
import { AddButton, CreateButton } from "../../../components/ButttonsWithIcons.js";
import { HorizontalTableIcon } from "./component/horizontalTableIcon.jsx";
import { VerticleTableIcon } from "./component/verticalTableIcon.jsx";
import { CircularTableIcon } from "./component/circleTableIcon.jsx";
import { useSnackbar } from "notistack";
import { CANVAS_WIDTH, CANVAS_HEIGHT, toNorm, getLinkSegment } from "./canvasConstants";
import { getTranslation } from "../../../heplers/translationHelper";

const TableCanvas = ({
  selectedArea,
  selectedTable,
  formdata,
  dayTime,
  enableMove,
  enableReservation,
  onTableSelected,
  selectedForMerge,
  setSelectedForMerge,
  isMerging: isMergingProp,
  setIsMerging: setIsMergingProp,
}) => {
  const canvasRef = useRef(null);
  const [tables, setTables] = useState([]);
  const [editTable, setEditTable] = useState(null);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);
  const [clickCanvasPosition, setClickCanvasPosition] = useState(null);
  const [isMergingState, setIsMergingState] = useState(false);
  // merge mode can be controlled by the parent (button placed next to the room list)
  const isMergeControlled = isMergingProp !== undefined && !!setIsMergingProp;
  const isMerging = isMergeControlled ? isMergingProp : isMergingState;
  const setIsMerging = isMergeControlled ? setIsMergingProp : setIsMergingState;
// const [selectedForMerge, setSelectedForMerge] = useState([]);
const {enqueueSnackbar} =useSnackbar()
  
  const [dragging, setDragging] = useState(false);

  useEffect(async () => {
    if (selectedArea?.id) loadTables(selectedArea.id);
  }, [selectedArea,formdata?.timeSlotId,dayTime.dayTime]);

  const loadTables = async (areaId) => {
    if (enableReservation || formdata) {
  console.log("kjadkjasdhasjasdadsa",dayTime)
      await Get(
        {
          areaId: areaId,
          date: formdata.reservationDate,
          timeSlotId: formdata?.timeSlots[0].id,
          dayTime:dayTime.dayTime
        },
        "Reservation/GetAvailableTables",
        null,
        (response) => {
          setTables(response.data.map(t => ({
            ...t,
            positionX: toNorm(t.positionX, CANVAS_WIDTH),
            positionY: toNorm(t.positionY, CANVAS_HEIGHT),
          })));
        },
        (error) => {
          console.error(`Error fetching tables for area ${areaId}:`, error);
        }
      );
    } else {
      await Get(
        null,
        `TableManagement/GetAllTables?areaId=${areaId}&dayTime=${dayTime.dayTime}`,
        null,
        (response) => {
          console.log(`Fetched tables for area ${areaId}:`, response.data);
          setTables(response.data.map(t => ({
            ...t,
            positionX: toNorm(t.positionX, CANVAS_WIDTH),
            positionY: toNorm(t.positionY, CANVAS_HEIGHT),
          })));
        },
        (error) => {
          console.error(`Error fetching tables for area ${areaId}:`, error);
        }
      );
    }

    return ()=>{
      setTables([])
    }
  };

  const handleCreateTable = async (values, actions) => {
    const tableWidth = 60;
    const tableHeight = 40;

    const requestBody = {
      persons: values.persons,
      quantity: 1,
      positionX: clickCanvasPosition?.x,
      positionY: clickCanvasPosition?.y,
      shape: values.shape,
      areaId: selectedArea.id,
      dayTime: dayTime.dayTime,
      reference:values.reference
    };

    try {
      await Post(
        editTable?values:requestBody,
        "TableManagement/UpsertTable",
        null,
        async (response) => {

          // setCurrentPosition(response.data.id)
          // await fetchTablesForAllAreas(queryParams.dayTime);
          loadTables(selectedArea.id);

          setOpenCreateDialog(false);
          if(editTable)
            setEditTable(null)
        },
        (error) => {
          if(editTable)
            alert(
              `${getTranslation("Error updating table")}: ${getTranslation(error?.data?.message || "Unknown error")}`
            );
            else
            alert(
            `${getTranslation("Error creating table")}: ${getTranslation(error?.data?.message || "Unknown error")}`
          );
        }
      );
    } catch (error) {
      console.error("Error creating table:", error);
    }
  };

  const handleDragEnd = async (id, x, y) => {
    const table = tables.find(t => t.id == id);
    const requestBody = {
      ...table,
      positionX: x,
      positionY: y,
      areaId: selectedArea.id,
      dayTime: dayTime.dayTime,
    };

    try {
      await Post(
        requestBody,
        "TableManagement/UpsertTable",
        null,
        (response) => {
          // setSelectedTable(null);
        },
        (error) => {
          console.error("Error updating table position:", error);
          //alert(`Error updating table position: ${error?.data?.message || "Unknown error"}`);
        }
      );
    } catch (error) {
      console.error("Error updating table position:", error);
    }
  };

  // const handleReplacementToggle = () => {
  //   setReplacementMode(!replacementMode);
  // };
  const handleDrag = (id, x, y) => {
    console.log("kasdasdasdasdadasd",id,x,y)
    setTables((prevTables) =>
      prevTables.map((table) =>
        table.id === id ? { ...table, positionX: x, positionY: y } : table
      )
    );
  };

  const handleDivClick = (e) => {
    // If the click is directly on the div and not a child
    if (e.target === e.currentTarget && enableReservation!=true) {
      // Get the position of the div relative to the viewport
      const divRect = e.currentTarget.getBoundingClientRect();
  
      // Store as normalized (0–1) fraction of canvas size
      const x = (e.clientX - divRect.left) / CANVAS_WIDTH;
      const y = (e.clientY - divRect.top)  / CANVAS_HEIGHT;

      setOpenCreateDialog(true);
      setClickCanvasPosition({ x, y });
    }
  };

  const handleEditClick=(table)=>{
    setEditTable(table)
    setOpenCreateDialog(true)
  }

  const getStatus=(table)=>{

      // if multiple table select
  if (isMerging && selectedForMerge?.some((x) => x?.id == table.id)) {
    return "booked";
  }
    // case if table was available and user has selected it
    if(table.available && selectedForMerge.find(x=>x?.id==table.id))
      return "booked"
    // if table is available for booking
    if(table.available)
      return "available"
    // if table is not available but its already booked by user
    if(table.available==false && selectedForMerge.find(x=>x?.id==table.id))
      return "booked"
    if(table.available==false && formdata?.tableReserved?.split("|").find(x=>x.split(",")[0]==table.id))
      return "available"
    
    return "blocked"
  }

  const handleCheckboxToggle = (id) => {
    setSelectedForMerge((prev) => {
      const updated = prev.includes(id)
        ? prev.filter((tid) => tid !== id)
        : [...prev, id];
  
      console.log("Selected Tables for Merge:", updated);
      setIsMerging(updated.length > 0);
      return updated;
    });
  };
  

  const handleSelectedTable = (table) => {
    if (setSelectedForMerge) {
      if (selectedForMerge?.find(x => x?.id == table.id)) {
        setSelectedForMerge(selectedForMerge.filter(x => x.id != table.id))
        return;
      }
      else if (table.available == false && formdata?.tableReserved?.split("|").find(x => x.split(",")[0] == table.id)) {
        if (isMerging)
          setSelectedForMerge([...selectedForMerge, table])
        else
          setSelectedForMerge([table])

        return;
      }
      else if (table.available == false) {
        alert(getTranslation("This table is not available."))
        return;
      }

      if (isMerging) {
        setSelectedForMerge([...selectedForMerge, table])
      } else {
        setSelectedForMerge([table])
      }
    }
  }

  const handleDelete=(table)=>{
Post({
  id:table.id
},"TableManagement/DeleteTable",
null,
resp=>{
  loadTables(selectedArea.id)
  enqueueSnackbar(getTranslation("Table deleted"),{variant:"success"})
},
error=>{
  enqueueSnackbar(getTranslation("Table deleted"),{variant:"error"})

}
)
  }
  const chosenTables = (selectedForMerge || [])
    .map((s) => tables.find((t) => t.id == (s?.id ?? s)))
    .filter(Boolean);
  const mergeLinks = chosenTables
    .slice(1)
    .map((t, i) => getLinkSegment(chosenTables[i], t))
    .filter(Boolean);

  return (
    <Box
      style={{
        position: "relative",
      }}
       boxShadow={6} 
  borderRadius={4} 
  p={0} 
  height={580}
  width={1400}
      onClick={handleDivClick}
      
    >

{/* the merge button is rendered by the parent when it controls the merge state */}
{!isMergeControlled && (
<Box
      sx={{
        display: 'flex',
        flexDirection:'row',
        gap:'6px',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
      }}
    >
      {isMerging && (
  <span style={{ fontSize:'14px', color:"#B00020", marginTop:'9px',  }}>
    {getTranslation("You can select multiple tables for merging")}
  </span>
)}
<Button
  variant="contained"
  onClick={() => {
    // merging adds tables to the ones already chosen (click a chosen table to remove it)
    setIsMerging(!isMerging);
  }}
>
  {isMerging ? getTranslation("Confirm") : getTranslation("Merge")}
</Button>



    </Box>
)}
    

      {tables.map((table) =>
        table.shape == "horizontalRectangle" ? (
          <HorizontalTableIcon
            key={table.id}
            id={table.id}
            x={table.positionX}
            y={table.positionY}
            status={getStatus(table)}
            reference={table.reference}
            persons={table.persons}
            enableDrag={enableMove}
            onDrag={handleDrag}
            isMerging={isMerging}
            // onCheckboxToggle={isMerging ? handleCheckboxToggle : null}
            onClick={() => {
              // setSelectedTable(table.id)
              console.log("jihlsadhgdghhda click",table)
              
                handleSelectedTable(table)
            }}
            onDragStop={handleDragEnd}
            onEdit={()=>{
              handleEditClick(table)
            }}
            onDelete={()=>handleDelete(table)}
          />
        ) : table.shape == "verticalRectangle" ? (
          <VerticleTableIcon
            key={table.id}
            id={table.id}
            x={table.positionX}
            y={table.positionY}
            status={getStatus(table)}
            reference={table.reference}
            persons={table.persons}
            onDrag={handleDrag}
            enableDrag={enableMove}
            isMerging={isMerging}
            onClick={() => {
              // setSelectedTable(table.id)
              
                handleSelectedTable(table)
            }}
            onDragStop={handleDragEnd}
            onEdit={()=>{
              handleEditClick(table)
            }}
            onDelete={()=>handleDelete(table)}
          />
        ) : (
<CircularTableIcon
  key={table.id}
  id={table.id}
  x={table.positionX}
  y={table.positionY}
  status={getStatus(table)}
  reference={table.reference}
  persons={table.persons}
  onDrag={handleDrag}
  isMerging={isMerging}
  onClick={() => {
    // setSelectedTable(table.id)
      handleSelectedTable(table)
  }}
  onDragStop={handleDragEnd}
  enableDrag={enableMove}
  onEdit={()=>{
    handleEditClick(table)
  }}
  onDelete={()=>handleDelete(table)}

/>

        )
      )}
      {/* merged tables: a dashed line links the chosen tables, in the order they were chosen */}
      {mergeLinks.length > 0 && (
        <svg
          width={CANVAS_WIDTH}
          height={CANVAS_HEIGHT}
          style={{ position: "absolute", left: 0, top: 0, pointerEvents: "none", overflow: "visible" }}
        >
          {mergeLinks.map(([x1, y1, x2, y2], i) => (
            <g key={i}>
              <line x1={x1} y1={y1} x2={x2} y2={y2} stroke="#fff" strokeWidth={7} strokeLinecap="round" />
              <line x1={x1} y1={y1} x2={x2} y2={y2} stroke="#1565C0" strokeWidth={4} strokeDasharray="10 6" strokeLinecap="round" />
            </g>
          ))}
        </svg>
      )}
      {/* <canvas
        ref={canvasRef}
        width={600}
        height={600}
        onClick={handleCanvasClick}
        onMouseDown={handleDragStart}
        onMouseMove={handleDragMove}
        onMouseUp={handleDragEnd}
        style={{
          border: "1px solid black",
          marginRight: "10px",
          marginLeft: "2px",
        }}
      /> */}
      <AddNewTable
        open={openCreateDialog}
        onClose={() => setOpenCreateDialog(false)}
        onSubmit={handleCreateTable}
        editTable={editTable}
      />
    </Box>
  );
};

export default TableCanvas;
